import { Injectable } from '@angular/core';

/*
  Generated class for the ImportProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImportProvider {

  constructor() {
    console.log('Hello ImportProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/import/import.ts